import { getSellerMarketStatus, readAdvisorBuyerNdas, recordAdvisorNdaSignature } from "./advisorWorkspaceData";

export const BUYER_CASES = Object.freeze([
  {
    id: "AR-083402",
    title: "SaaS / Tech business seeking acquirer",
    company: "CloudLedger Systems",
    sector: "Technology, Software & Digital Services",
    subsector: "SaaS / Enterprise Software",
    location: "Hanoi",
    transactionValue: 310000000000,
    revenue: 188000000000,
    ebitda: 42000000000,
    employees: "200 - 249",
    reasonForSelling: "Retirement and succession planning",
    listedDays: 20,
    updatedAt: "2026-08-29T08:15:00+07:00",
    reachedOut: true,
    responded: true,
    overview: "A recurring-revenue B2B software platform serving finance and operations teams across Vietnam and Southeast Asia. The company combines workflow automation, reporting, and enterprise integrations in a single subscription product.",
    advisor: { name: "Minh Pham", role: "Mergers Advisor", initials: "MP" },
    financials: { years: ["2025"], revenue: [188], ebitda: [42], profit: [null] },
    plusPoints: ["Recurring subscription revenue", "High customer retention", "Regional enterprise pipeline"],
    minusPoints: ["Customer concentration in top accounts", "Growth requires continued product investment", "Founder remains important to sales"],
    marketPotential: "Enterprise digitisation and finance automation remain durable demand drivers across the region, with increasing willingness to replace fragmented legacy workflows.",
    documents: ["Information memorandum", "FY2025 financial statements", "Product overview"],
  },
  {
    id: "AR-901218",
    title: "Security software platform",
    company: "SentinelMesh",
    sector: "Technology, Software & Digital Services",
    subsector: "SaaS / Cybersecurity",
    location: "Ho Chi Minh City",
    transactionValue: 275000000000,
    revenue: 154000000000,
    ebitda: 31000000000,
    employees: "150 - 199",
    reasonForSelling: "Strategic growth partner",
    listedDays: 12,
    updatedAt: "2026-08-28T13:20:00+07:00",
    reachedOut: false,
    responded: false,
    overview: "A cybersecurity software business focused on managed detection, network visibility, and security operations workflows for mid-market enterprises.",
    advisor: { name: "Linh Tran", role: "Mergers Advisor", initials: "LT" },
    financials: { years: ["2025"], revenue: [154], ebitda: [31], profit: [null] },
    plusPoints: ["Strong recurring contracts", "Security demand tailwind", "Low customer churn"],
    minusPoints: ["Competitive hiring market", "Enterprise sales cycles are long", "International expansion still early"],
    marketPotential: "Security spending continues to move from discretionary IT into core operating infrastructure, supporting resilient demand for recurring managed-security platforms.",
    documents: ["Information memorandum", "Security product brief"],
  },
  {
    id: "AR-334150",
    title: "Digital services and cloud integrator",
    company: "Northstar Digital",
    sector: "Technology, Software & Digital Services",
    subsector: "IT Services / Cloud Integration",
    location: "Da Nang",
    transactionValue: 290000000000,
    revenue: 231000000000,
    ebitda: 36000000000,
    employees: "250 - 299",
    reasonForSelling: "Shareholder liquidity",
    listedDays: 31,
    updatedAt: "2026-08-27T10:05:00+07:00",
    reachedOut: true,
    responded: false,
    overview: "A cloud and digital transformation integrator serving regulated and enterprise customers with implementation, migration, and managed-services capabilities.",
    advisor: { name: "Anh Vu", role: "Mergers Advisor", initials: "AV" },
    financials: { years: ["2025"], revenue: [231], ebitda: [36], profit: [null] },
    plusPoints: ["Blue-chip customer base", "Strong delivery capability", "Growing managed-services mix"],
    minusPoints: ["Project revenue can be lumpy", "Dependence on certified technical staff", "Margin below pure software peers"],
    marketPotential: "Cloud migration and managed-service adoption are expected to remain strong as enterprises modernise infrastructure without expanding internal engineering teams at the same pace.",
    documents: ["Information memorandum", "FY2025 financial statements"],
  },
  {
    id: "AR-661476",
    title: "Premium food manufacturer",
    company: "Mekong Harvest Foods",
    sector: "Food & Beverage Manufacturing",
    subsector: "Packaged Foods",
    location: "Can Tho",
    transactionValue: 180000000000,
    revenue: 260000000000,
    ebitda: 29000000000,
    employees: "300 - 349",
    reasonForSelling: "Founder succession",
    listedDays: 8,
    updatedAt: "2026-08-29T07:30:00+07:00",
    reachedOut: true,
    responded: true,
    overview: "A branded packaged-food manufacturer with modern retail distribution and private-label production for regional customers.",
    advisor: { name: "Bao Nguyen", role: "Mergers Advisor", initials: "BN" },
    financials: { years: ["2025"], revenue: [260], ebitda: [29], profit: [null] },
    plusPoints: ["Established retail distribution", "Recognised regional brand", "Stable cash conversion"],
    minusPoints: ["Raw-material price exposure", "Concentrated manufacturing footprint", "Category growth is moderate"],
    marketPotential: "Premiumisation and modern retail penetration continue to support branded packaged-food demand, although category growth remains more mature than digital sectors.",
    documents: ["Information memorandum", "FY2025 financial statements", "Factory overview"],
  },
  {
    id: "AR-547802",
    title: "Industrial automation services",
    company: "Vector Automation",
    sector: "Manufacturing",
    subsector: "Industrial Automation",
    location: "Binh Duong",
    transactionValue: 360000000000,
    revenue: 312000000000,
    ebitda: 52000000000,
    employees: "200 - 249",
    reasonForSelling: "Strategic partner sought",
    listedDays: 16,
    updatedAt: "2026-08-26T15:10:00+07:00",
    reachedOut: false,
    responded: false,
    overview: "An engineering and industrial automation provider serving export-oriented manufacturers with controls, robotics integration, and maintenance services.",
    advisor: { name: "Trang Le", role: "Mergers Advisor", initials: "TL" },
    financials: { years: ["2025"], revenue: [312], ebitda: [52], profit: [null] },
    plusPoints: ["Long-term industrial customers", "Technical service moat", "Recurring maintenance revenue"],
    minusPoints: ["Project timing affects quarters", "Customer capex sensitivity", "Specialist engineering recruitment"],
    marketPotential: "Automation demand benefits from manufacturing relocation, labour-productivity pressure, and increasingly sophisticated quality requirements in export supply chains.",
    documents: ["Information memorandum", "FY2025 financial statements"],
  },
]);

export const BUYER_NOTIFICATIONS = Object.freeze([
  { id: "n1", title: "NDA ready for signature", detail: "CloudLedger Systems · AR-083402", time: "18 min ago" },
  { id: "n2", title: "Advisor replied to your outreach", detail: "Mekong Harvest Foods · AR-661476", time: "2 hr ago" },
]);

export const BUYER_TODOS = Object.freeze([
  { id: "t1", title: "Review NDA for AR-083402", due: "Today" },
  { id: "t2", title: "Review newly added opportunity", due: "Today" },
  { id: "t3", title: "Follow up on AR-334150", due: "Tomorrow" },
]);

export const BUYER_NDAS = Object.freeze([
  { id: "NDA-083402", caseId: "AR-083402", offeredAt: "2026-08-29T08:20:00+07:00", status: "pending" },
  { id: "NDA-661476", caseId: "AR-661476", offeredAt: "2026-08-27T10:10:00+07:00", status: "signed", signedAt: "2026-08-27T14:32:00+07:00", signer: "Alex Nguyen" },
  { id: "NDA-334150", caseId: "AR-334150", offeredAt: "2026-08-26T09:05:00+07:00", status: "signed", signedAt: "2026-08-26T11:18:00+07:00", signer: "Alex Nguyen" },
]);

export const DEMO_BUYER_PROFILE = Object.freeze({
  desiredSector: "Technology, Software & Digital Services",
  desiredSubsector: "SaaS",
  budgetMin: 100000000000,
  budgetMax: 400000000000,
});

const WATCHLIST_KEY = "aragon.buyer.watchlist.v1";
const NDA_STATE_KEY = "aragon.buyer.nda-state.v1";
const DEFAULT_WATCHLIST = Object.freeze([
  { id: "AR-083402", addedAt: "2026-08-29T09:10:00+07:00" },
  { id: "AR-661476", addedAt: "2026-08-28T15:25:00+07:00" },
  { id: "AR-334150", addedAt: "2026-08-27T12:40:00+07:00" },
]);

function normalize(value) {
  return String(value || "").trim().toLocaleLowerCase();
}

function canUseSessionStorage() {
  return typeof window !== "undefined" && Boolean(window.sessionStorage);
}

export function getCaseById(caseId) {
  return BUYER_CASES.find((item) => item.id === caseId) || null;
}

export function rankBuyerCases(profile = DEMO_BUYER_PROFILE) {
  const min = Number(profile?.budgetMin) || DEMO_BUYER_PROFILE.budgetMin;
  const max = Number(profile?.budgetMax) || DEMO_BUYER_PROFILE.budgetMax;
  const low = Math.min(min, max);
  const high = Math.max(min, max);
  const preferredLow = low + (high - low) * 0.5;
  const preferredHigh = low + (high - low) * 0.9;
  const desiredSector = normalize(profile?.desiredSector || DEMO_BUYER_PROFILE.desiredSector);
  const desiredSubsector = normalize(profile?.desiredSubsector || DEMO_BUYER_PROFILE.desiredSubsector);
  return BUYER_CASES
    .filter((item) => getSellerMarketStatus(item.id) === "approved")
    .map((item) => {
      const inRange = item.transactionValue >= low && item.transactionValue <= high;
      const sectorMatch = normalize(item.sector) === desiredSector;
      const caseSubsector = normalize(item.subsector);
      const subsectorMatch = Boolean(desiredSubsector) && (caseSubsector.includes(desiredSubsector) || desiredSubsector.includes(caseSubsector));
      const inPreferredBand = item.transactionValue >= preferredLow && item.transactionValue <= preferredHigh;
      let priority = 0;
      if (sectorMatch && subsectorMatch && inPreferredBand) priority = 3;
      else if (sectorMatch && inRange) priority = 2;
      else if (inRange) priority = 1;
      return { item, priority };
    })
    .filter(({ priority }) => priority > 0)
    .sort((a, b) => b.priority - a.priority || new Date(b.item.updatedAt) - new Date(a.item.updatedAt))
    .map(({ item }) => item);
}

export function formatVndCompact(value) {
  const numeric = Number(value);
  if (!Number.isFinite(numeric)) return "—";
  if (Math.abs(numeric) >= 1000000000) return `VND ${(numeric / 1000000000).toFixed(numeric % 1000000000 === 0 ? 0 : 1)}B`;
  if (Math.abs(numeric) >= 1000000) return `VND ${(numeric / 1000000).toFixed(numeric % 1000000 === 0 ? 0 : 1)}M`;
  return `VND ${numeric.toLocaleString("en-US")}`;
}

export function readWatchlist() {
  if (!canUseSessionStorage()) return [...DEFAULT_WATCHLIST];
  const raw = window.sessionStorage.getItem(WATCHLIST_KEY);
  if (!raw) {
    window.sessionStorage.setItem(WATCHLIST_KEY, JSON.stringify(DEFAULT_WATCHLIST));
    return [...DEFAULT_WATCHLIST];
  }
  try {
    const parsed = JSON.parse(raw);
    return Array.isArray(parsed) ? parsed : [...DEFAULT_WATCHLIST];
  } catch {
    return [...DEFAULT_WATCHLIST];
  }
}

export function isWatched(caseId) {
  return readWatchlist().some((entry) => entry.id === caseId);
}

export function toggleWatchlist(caseId) {
  const current = readWatchlist();
  const exists = current.some((entry) => entry.id === caseId);
  const next = exists
    ? current.filter((entry) => entry.id !== caseId)
    : [{ id: caseId, addedAt: new Date().toISOString() }, ...current];
  if (canUseSessionStorage()) window.sessionStorage.setItem(WATCHLIST_KEY, JSON.stringify(next));
  return { watched: !exists, entries: next };
}

export function getBuyerNdas() {
  const linked = readAdvisorBuyerNdas();
  const byId = new Map([...BUYER_NDAS, ...linked].map((agreement) => [agreement.id, agreement]));
  return [...byId.values()];
}

export function readNdaState() {
  const base = Object.fromEntries(getBuyerNdas().map((agreement) => [agreement.id, { ...agreement }]));
  if (!canUseSessionStorage()) return base;
  const raw = window.sessionStorage.getItem(NDA_STATE_KEY);
  if (!raw) return base;
  try {
    const parsed = JSON.parse(raw);
    return { ...base, ...parsed };
  } catch {
    return base;
  }
}

export function signNda(agreementId, signer) {
  const current = readNdaState();
  const signedAt = new Date().toISOString();
  const next = {
    ...current,
    [agreementId]: {
      ...current[agreementId],
      status: "signed",
      signedAt,
      signer,
    },
  };
  if (canUseSessionStorage()) window.sessionStorage.setItem(NDA_STATE_KEY, JSON.stringify(next));
  recordAdvisorNdaSignature(agreementId, signer, signedAt);
  return next;
}
